import styled from 'styled-components';

export const ActionsGroup = styled.div`
    && {
        display: flex;
        width: 100%;
        gap: 10px;
    }
`;

export const DropdownFilterHeading = styled.p`
    box-sizing: border-box;
    color: ${({ theme }) => theme.colors.white};
    display: inline-block;
    font-family: 'Alliance No.1';
    font-size: 0.875rem;
    font-style: normal;
    font-weight: 700;
    justify-content: flex-start;
    letter-spacing: 0.02em;
    line-height: 1;
    margin: 0;
    overflow: hidden;
    padding: 10px 0 5px 0;
    text-align: left;
    text-overflow: ellipsis;
    text-transform: uppercase;
    white-space: nowrap;
`;

export const Description = styled.p`
    font-family: 'Alliance No.1';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 120%;
    letter-spacing: -0.03em;
    color: ${({ theme }) => theme.colors.white};
    display: block;
    margin-top: 0;
`;
